import Layout from '@/layout';

export default [
  {
    path: '/studio',
    name: 'Studio',
    redirect: '/studio/introduceManager',
    component: Layout,
    meta: {
      title: '工作室',
      icon: 'icon-studio',
    },
    children: [
      {
        path: 'introduceManager',
        name: 'StudioIntroduceManager',
        component: () => import('@/views/studio/introduceManager.vue'),
        meta: {
          title: '工作室概况',
        },
      },
      {
        path: 'detailPage/:member_id',
        name: 'detailPage',
        component: () => import('@/views/studio/components/detailPage.vue'),
        meta: {
          title: '成员数据明细',
          //activePath: 'introduceManager'
        },
        hidden: true,
      },
      {
        path: 'dataDetails',
        name: 'dataDetails',
        component: () =>
          import('@/views/studio/components/introduceManager/dataDetails.vue'),
        meta: {
          title: '工作室概况-数据详情',
          activePath: 'introduceManager',
        },
        hidden: true,
        children: [
          {
            path: 'studioOverview',
            name: 'studioOverview',
            component: () =>
              import(
                '@/views/studio/components/introduceManager/studioOverview.vue'
              ),
            meta: {
              title: '工作室概况-数据详情-工作室概况',
              activePath: 'dataDetails',
            },
            hidden: true,
          },
          {
            path: 'membersDataTable',
            name: 'membersDataTable',
            component: () =>
              import(
                '@/views/studio/components/introduceManager/membersDataTable.vue'
              ),
            meta: {
              title: '工作室概况-数据详情-成员数据',
              activePath: 'dataDetails',
            },
          },
          {
            path: 'productDataTable',
            name: 'productDataTable',
            component: () =>
              import(
                '@/views/studio/components/introduceManager/productDataTable'
              ),
            meta: {
              title: '工作室概况-数据详情-作品数据',
              activePath: 'dataDetails',
            },
          },
        ],
      },
      {
        path: 'manager',
        name: 'StudioManager',
        redirect: 'manager/index',
        component: () => import('@/views/studio/manager.vue'),
        meta: {
          title: '工作室管理',
        },
        children: [
          {
            path: 'index',
            name: 'StudioManagerEntry',
            component: () =>
              import('@/views/studio/components/applyManager/index.vue'),
            meta: {
              title: '工作室管理',
              activePath: 'manager',
            },
            hidden: true,
          },
          {
            path: 'apply',
            name: 'StudioManagerApply',
            component: () =>
              import('@/views/studio/components/applyManager/apply.vue'),
            meta: {
              title: '加入退出申请',
              activePath: 'manager',
            },
            hidden: true,
          },
        ],
      },
      {
        path: 'settings',
        name: 'StudioSettings',
        redirect: 'settings/index',
        component: () => import('@/views/studio/settings.vue'),
        meta: {
          title: '工作室设置',
        },
        children: [
          {
            path: 'index',
            name: 'settingsEntry',
            component: () =>
              import('@/views/studio/components/settings/index.vue'),
            meta: {
              title: '工作室设置-信息',
              activePath: 'settings',
            },
            hidden: true,
          },
          {
            path: 'authentication',
            name: 'authentication',
            component: () =>
              import('@/views/studio/components/settings/authentication.vue'),
            meta: {
              title: '工作室设置-认证',
              activePath: 'settings',
            },
            hidden: true,
          },
          {
            path: 'updateBaseInfo',
            name: 'updateBaseInfo',
            component: () =>
              import('@/views/studio/components/settings/updateBaseInfo.vue'),
            meta: {
              title: '工作室设置-修改信息',
              activePath: 'settings',
            },
            hidden: true,
          },
          {
            path: 'beforeUpdateAuthInfo',
            name: 'beforeUpdateAuthInfo',
            component: () =>
              import(
                '@/views/studio/components/settings/beforeUpdateAuthInfo.vue'
              ),
            meta: {
              title: '工作室设置-修改信息',
              activePath: 'settings',
            },
            hidden: true,
          },
        ],
      },
      {
        path: 'Studiosettlement',
        name: 'StudioIncomeSettlement',
        component: () => import('@/views/income/StudioSettlement.vue'),
        meta: {
          title: '结算中心',
        },
      },
      // {
      //   path: 'StudioMemberIncome',
      //   name: 'StudioMemberIncome',
      //   component: () => import('@/views/income/StudioMemberIncome.vue'),
      //   meta: {
      //     title: '工作室成员收益',
      //   },
      // },
      {
        path: 'studioSettleDetail',
        name: 'studioSettleDetail',
        component: () => import('@/views/income/studioSettleDetail'),
        meta: {
          title: '提现记录',
          activePath: 'Studiosettlement',
        },
        hidden: true,
      },
    ],
  },
];
